// Ledgers dated strictly before the club's lock date are immutable (mirrors LedgerEntry.is_locked in the backend)
export function isDateLocked(date, lockBeforeDate) {
  if (!date || !lockBeforeDate) return false;
  return String(date).slice(0, 10) < lockBeforeDate;
}

export function isLedgerLocked(ledger, lockBeforeDate) {
  if (!ledger) return false;
  return isDateLocked(ledger.date_posting || ledger.date_created, lockBeforeDate);
}
